import React from "react";
import {
  Route,
  Switch,
  Redirect,
  withRouter,
} from "react-router-dom";
import classnames from "classnames";

// styles
import useStyles from "./styles";

// components
import Header from "../Header";
import Sidebar from "../Sidebar";

// pages
import Dashboard from "../../pages/dashboard";
import Patients from "../../pages/patients";
import Exercises from "../../pages/exercises";
import Articles from "../../pages/articles";
import PatientsDetails from "../../pages/patients/PatientsDetails";


import Typography from "../../pages/typography";
import Notifications from "../../pages/notifications";
import Maps from "../../pages/maps";
import Tables from "../../pages/tables";
import Icons from "../../pages/icons";
import Charts from "../../pages/charts";
import Users from "../../pages/users/Users";

// context
import { useLayoutState } from "../../context/LayoutContext";
import Templates from "../../pages/templates/Templates";
import Dictionaries from "../../pages/dictionaries/Dictionaries";
import PatientsList from "../../pages/patients/PatientsList";




function Layout(props) {
  var classes = useStyles();


  // global
  var layoutState = useLayoutState();

  console.log('RENDER LAYOUT');

  return (
    <div className={classes.root}>
        <>
          <Header history={props.history} />
          <Sidebar />
          <div
            className={classnames(classes.content, {
              [classes.contentShift]: layoutState.isSidebarOpened,
            })}
          >
            <div className={classes.fakeToolbar} />
            <Switch>
              <Route exact path="/app/patients/list" component={PatientsList} />
              <Route exact path="/app/patients" component={Patients} />
              <Route path="/app/patients/:patientId" component={PatientsDetails} />
              <Route path="/app/exercises" component={Exercises} />
              <Route path="/app/articles" component={Articles} />
              <Route path="/app/templates" component={Templates} />
              <Route path="/app/dictionaries" component={Dictionaries} />
              <Route path="/app/users" component={Users} />


              <Route path="/app/dashboard" component={Dashboard} />
              <Route path="/app/typography" component={Typography} />
              <Route path="/app/tables" component={Tables} />
              <Route path="/app/notifications" component={Notifications} />
              <Route
                exact
                path="/app/ui"
                render={() => <Redirect to="/app/ui/icons" />}
              />
              <Route path="/app/ui/maps" component={Maps} />
              <Route path="/app/ui/icons" component={Icons} />
              <Route path="/app/ui/charts" component={Charts} />
            </Switch>
          </div>
        </>
    </div>
  );
}

export default withRouter(Layout);
